var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1344,
    height: 1165,
    viewBox: "0 0 1344 1165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M671.85 233.23C671.73 233.256 671.637 233.326 671.57 233.44C492.883 543.213 314.223 852.943 135.589 1162.63C135.329 1163.08 134.943 1163.3 134.43 1163.3H1.73869C1.4589 1163.3 1.34898 1163.16 1.40894 1162.89C1.46223 1162.65 1.55216 1162.42 1.67874 1162.21C224.966 775.076 448.286 387.91 671.64 0.709763C671.671 0.657992 671.715 0.615152 671.768 0.585411C671.82 0.55567 671.88 0.540039 671.94 0.540039C672 0.540039 672.06 0.55567 672.112 0.585411C672.165 0.615152 672.209 0.657992 672.24 0.709763L1342.55 1162.77C1342.75 1163.12 1342.65 1163.3 1342.24 1163.3L1209.25 1163.31C1208.88 1163.31 1208.59 1163.15 1208.4 1162.82L672.31 233.44C672.21 233.26 672.057 233.19 671.85 233.23Z",
    fill: "url(#paint0_linear_21_15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M403.32 1163.3L270.129 1163.31C270.053 1163.31 269.978 1163.29 269.913 1163.25C269.847 1163.21 269.793 1163.16 269.755 1163.09C269.717 1163.03 269.698 1162.95 269.699 1162.88C269.699 1162.8 269.72 1162.73 269.759 1162.66L671.57 466.09C671.608 466.026 671.662 465.972 671.727 465.935C671.792 465.898 671.865 465.879 671.94 465.879C672.015 465.879 672.088 465.898 672.153 465.935C672.218 465.972 672.272 466.026 672.31 466.09L1074.12 1162.67C1074.16 1162.73 1074.18 1162.81 1074.18 1162.88C1074.17 1162.96 1074.15 1163.03 1074.12 1163.1C1074.08 1163.16 1074.03 1163.21 1073.96 1163.25C1073.9 1163.29 1073.83 1163.31 1073.75 1163.31H940.57C940.495 1163.31 940.421 1163.29 940.356 1163.25C940.291 1163.21 940.237 1163.16 940.2 1163.09L672.31 698.69C672.272 698.626 672.218 698.572 672.153 698.535C672.088 698.498 672.015 698.479 671.94 698.479C671.865 698.479 671.792 698.498 671.727 698.535C671.662 698.572 671.608 698.626 671.57 698.69L403.69 1163.08C403.653 1163.15 403.599 1163.2 403.534 1163.24C403.469 1163.28 403.395 1163.3 403.32 1163.3Z",
    fill: "url(#paint1_linear_21_15)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M671.5 1163C721.169 1163 761.434 1122.71 761.434 1073C761.434 1023.29 721.169 983 671.5 983C621.832 983 581.567 1023.29 581.567 1073C581.567 1122.71 621.832 1163 671.5 1163Z",
    fill: "url(#paint2_linear_21_15)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_15",
    x1: 672.021,
    y1: 0.540039,
    x2: 672.021,
    y2: 1163.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6951F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_15",
    x1: 671.937,
    y1: 465.879,
    x2: 671.937,
    y2: 1163.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6951F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_15",
    x1: 671.5,
    y1: 983,
    x2: 671.5,
    y2: 1163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6951F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.70e898eeb0204768b8bc49944d19c97c.svg";
export { ForwardRef as ReactComponent };